import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Config } from "../_store";

@Injectable({
  providedIn: "root",
})
export class PosService {
  purchaseOrders: any;
  poType: any;

  constructor(private http: HttpClient) {}

  fetchPurchaseOrders(data: any) {
    return this.http.post(Config.urls.PURCHASEODERS, data);
  }

  fetchCNDN(data: any) {
    return this.http.post(Config.urls.GET_CN_DN, data);
  }

  fetchPurchaseOrderDetails(data: any) {
    return this.http.post(Config.urls.PURCHASEORDERDETAILS, data);
  }

  fetchLineItems(data: any) {
    return this.http.post(Config.urls.LINEITEMS, data);
  }

  setPos(data: any) {
    this.purchaseOrders = data;
  }

  getPos() {
    return this.purchaseOrders;
  }

  setPoType(data: any) {
    this.poType = data;
  }

  getPoType() {
    return this.poType;
  }
}
